export const AEROSYNC_WIDGET_CONTAINER_ID = "aerosync-widget-container"
export const AEROSYNC_WIDGET_IFRAME_ID = "aerosync-widget"
export const AEROSYNC_EMBEDDED_IFRAME_ID = "aerosync-embedded"
export const AEROSYNC_VERSION = '2.0.0'